export default {"src":"/_next/static/media/icon-affiliate.8516b708.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};